// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3N0un","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2r-h1","obliqueLine":"membershipbadge_obliqueLine__1YoT6"};